import { SESSION_STORAGE_KEYS, SUBMODULE_TYPE } from '@constants/constants';
import { SessionStorage } from '@utils/storage';
import { DEEP_LINK_CONFIG } from '../constants';

export const isDeepLinkSubmodule = (value: string | null): value is SUBMODULE_TYPE =>
  Boolean(value && DEEP_LINK_CONFIG[value as SUBMODULE_TYPE]);

export const getDeepLinkSubmodule = (): SUBMODULE_TYPE | null => {
  const submodule = SessionStorage.getItem(SESSION_STORAGE_KEYS.SUBMODULE_TO_REDIRECT);
  return isDeepLinkSubmodule(submodule) ? submodule : null;
};
